import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "d-flex align-center justify-space-between",
  style: {"width":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column align-center ma-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_EatingStatusItem = _resolveComponent("EatingStatusItem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName), 1),
      (_ctx.meal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              variant: "text",
              color: "primary",
              onClick: _ctx.fullEat,
              disabled: _ctx.fullBtnLoading
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("すべて完食", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.meal)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                class: "pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: '主食',
                    item: _ctx.meal.stapleFood,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "pl-0 pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: '主菜',
                    item: _ctx.meal.mainDish,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "pl-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: '副菜',
                    item: _ctx.meal.sideDish,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "5",
                class: "pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: '汁もの',
                    item: _ctx.meal.soup,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "5",
                class: "pl-0 pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: 'デザート',
                    item: _ctx.meal.dessert,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                class: "pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: '牛乳',
                    item: _ctx.meal.milk,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "pl-0 pr-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EatingStatusItem, {
                    text: 'おやつ',
                    item: _ctx.meal.snack,
                    onChangeStatusItem: _ctx.changeStatusItem
                  }, null, 8, ["item", "onChangeStatusItem"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            variant: "underlined",
            "single-line": "",
            rows: "1",
            "hide-details": "",
            density: "compact",
            placeholder: "コメントを入力",
            "prepend-inner-icon": "mdi-note-outline",
            modelValue: _ctx.inputComment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputComment) = $event)),
            loading: _ctx.btnLoading,
            color: "primary"
          }, {
            append: _withCtx(() => [
              (_ctx.inputComment)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    onClick: _ctx.sendMessage,
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" mdi-send ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "loading"])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            color: "primary",
            outlined: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createMealReport(_ctx.child.childId)))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("+記録を追加 ", -1)
            ]))]),
            _: 1
          })
        ]))
  ]))
}